module.exports = __webpack_public_path__ + "img/cv.1df7b470.png";